// Zuerst der Kern: seine Modul-Kette bringt die SCSS von `@core/frontend/ui` mit, damit das
// App-Theme darueber liegt (gleiche Reihenfolge wie vor dem Cutover).
import { renderApp } from '@core/frontend';
// Registriert das Custom Element `tabler-icon` (einmal pro Seite) — es kommt aus
// `@core/ui`, weil Cockpits und Frontends dieselbe Komponente nutzen.
import '@core/ui/DynamicIcon';

import './assets/scss/app.scss';

import { product } from './product';

/**
 * Einstiegspunkt des Fördertopfs.
 *
 * Hier bleibt nur, was zur App gehoert (das globale SCSS). Router, Provider, Service-Worker-
 * Abbau und Cache-Leerung liegen in `renderApp` aus `@core/frontend`.
 */
renderApp(product);
